import { ConfirmCompareProducts } from "@redotech/redo-model/agents/support-agents/confirm-compare-products";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import * as productComparisonTableCss from "./product-comparison-table.module.css";

interface ProductComparisonTableProps {
  comparison: ConfirmCompareProducts;
}

export const ProductComparisonTable = memo(function ProductComparisonTable({
  comparison,
}: ProductComparisonTableProps) {
  return (
    <Flex dir="column" gap="md" w="full">
      <Flex
        borderColor="primary"
        borderStyle="solid"
        borderWidth="1px"
        dir="column"
        gap="none"
        w="full"
      >
        <Flex
          borderBottomWidth="1px"
          borderColor="primary"
          borderStyle="solid"
          className={productComparisonTableCss.headerRow}
          dir="row"
          gap="none"
        >
          <Flex
            borderColor="primary"
            borderRightWidth="1px"
            borderStyle="solid"
            flex={1}
            p="sm"
          >
            <Text fontSize="xs" fontWeight="semibold" textColor="secondary">
              Feature
            </Text>
          </Flex>
          <Flex
            borderColor="primary"
            borderRightWidth="1px"
            borderStyle="solid"
            flex={1}
            p="sm"
          >
            <Text fontSize="xs" fontWeight="semibold" textColor="secondary">
              {comparison.currentProductTitle}
            </Text>
          </Flex>
          <Flex flex={1} p="sm">
            <Text fontSize="xs" fontWeight="semibold" textColor="secondary">
              {comparison.similarProductTitle}
            </Text>
          </Flex>
        </Flex>

        {comparison.comparisonFeatures.map((feature, index) => (
          <Flex dir="row" gap="none" key={index}>
            <Flex
              borderColor="tertiary"
              borderStyle="solid"
              borderWidth="1px"
              className={productComparisonTableCss.dataCell}
              flex={1}
              p="sm"
            >
              <Text fontSize="sm" fontWeight="semibold">
                {feature.name}
              </Text>
            </Flex>
            <Flex
              borderColor="tertiary"
              borderStyle="solid"
              borderWidth="1px"
              className={productComparisonTableCss.dataCell}
              flex={1}
              p="sm"
            >
              <Text fontSize="sm">{feature.currentProduct}</Text>
            </Flex>
            <Flex
              borderColor="tertiary"
              borderStyle="solid"
              borderWidth="1px"
              className={productComparisonTableCss.dataCell}
              flex={1}
              p="sm"
            >
              <Text fontSize="sm">{feature.similarProduct}</Text>
            </Flex>
          </Flex>
        ))}
      </Flex>

      {comparison.recommendation && (
        <Flex dir="column" gap="xs" pt="sm">
          <Text fontSize="xs" fontWeight="semibold" textColor="secondary">
            Recommendation
          </Text>
          <Text fontSize="sm">{comparison.recommendation}</Text>
        </Flex>
      )}
    </Flex>
  );
});
